module.exports = __webpack_public_path__ + "img/tavi_biel_ocular.96645395.jpg";